export const RECEIVE_POWER_TRANSFORMER_TYPES =
  'RECEIVE_POWER_TRANSFORMER_TYPES';
export const GET_POWER_TRANSFORMER_TYPES = 'GET_POWER_TRANSFORMER_TYPES';
export const SET_POWER_TRANSFORMER_TYPE = 'SET_POWER_TRANSFORMER_TYPE';
export const UPDATE_POWER_TRANSFORMER_TYPE = 'UPDATE_POWER_TRANSFORMER_TYPE';
export const DELETE_POWER_TRANSFORMER_TYPE = 'DELETE_POWER_TRANSFORMER_TYPE';
export const FETCH_POWER_TRANSFORMER_TYPES = 'FETCH_POWER_TRANSFORMER_TYPES';
